"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Class to handle all review Review Summary xlsx 2-d array building
 */
class ReviewSummaryBuilder {
    constructor(reviewTargetNames, reviewSamples) {
        this._reviewTargetNames = reviewTargetNames;
        this._reviewSamples = reviewSamples;
    }
    _buildReviewSummary() {
        const workbookHeaders = [
            ...ReviewSummaryBuilder._STANDARD_HEADERS,
            ...this._reviewTargetNames.reduce((acc, targetName) => [
                ...acc,
                ...ReviewSummaryBuilder._TARGET_HEADERS.map((targetHeader) => `${targetName} ${targetHeader}`),
            ], []),
        ];
        return this._reviewSamples.reduce((acc, reviewSample) => {
            const { targets: reviewSampleTargets } = reviewSample;
            const targetColumns = this._reviewTargetNames.reduce((acc, targetName) => {
                const associatedReviewTarget = reviewSampleTargets.find((reviewSampleTarget) => reviewSampleTarget.targetName === targetName);
                let associatedTargetColumns = ["", "", ""];
                if (associatedReviewTarget) {
                    associatedTargetColumns = [
                        associatedReviewTarget.comments,
                        associatedReviewTarget.cq,
                        associatedReviewTarget.cqOverride,
                    ];
                }
                return [...acc, ...associatedTargetColumns];
            }, []);
            return [
                ...acc,
                [
                    reviewSample.sampleId,
                    reviewSample.sampleResult,
                    reviewSample.patientLogDate,
                    reviewSample.runReviewerName,
                    reviewSample.runReviewerRole,
                    reviewSample.sampleStatus,
                    reviewSample.sampleFailureReason,
                    reviewSample.approvalStatus,
                    reviewSample.sampleComments,
                    reviewSample.runName,
                    reviewSample.runPassed,
                    reviewSample.runComments,
                    reviewSample.runProtocol,
                    ...targetColumns,
                ],
            ];
        }, [workbookHeaders]);
    }
    getReviewSummary() {
        return this._buildReviewSummary();
    }
}
ReviewSummaryBuilder._STANDARD_HEADERS = [
    "Sample ID",
    "Result",
    "Patient Log Date",
    "Reviewed By",
    "Reviewer Role",
    "Sample Status",
    "Failure Reason",
    "Approval Status",
    "Sample Comments",
    "Run Name",
    "Run Passed",
    "Run Comments",
    "Protocol",
];
ReviewSummaryBuilder._TARGET_HEADERS = ["Comments", "Cq", "Cq Override"];
exports.default = ReviewSummaryBuilder;
